/*
    🔥 DEFAULTS DE TODOS LOS CAMPOS

    ⚠️ EL AUTOCOMPLETADO — TRES CAPAS, PORQUE UNA SOLA NO ALCANZA

    1. autoComplete con un valor que Chrome NO reconozca ("nope").
       Frena el autocompletado común.

    2. El truco del readOnly. Chrome NUNCA autocompleta un campo de
       solo lectura. Arranca readOnly y se libera al primer foco, así
       que para el usuario es transparente pero Chrome ya perdió la
       oportunidad de rellenarlo.
       Esto es lo que frena el desplegable de DIRECCIONES GUARDADAS,
       que ignora por completo el atributo autoComplete.

    3. Los data-* para LastPass, 1Password y Dashlane, que inyectan
       sus íconos dentro del input y rompen el diseño.
*/

export const FIELD_AUTOCOMPLETE_OFF = 'nope';

export const FIELD_AUTOCOMPLETE_PASSWORD = 'new-password';

export const onResolveAutoComplete = (type, autoComplete) => {

    if (autoComplete) return autoComplete;              // el que pases vos manda

    if (type === 'password') return FIELD_AUTOCOMPLETE_PASSWORD;

    return FIELD_AUTOCOMPLETE_OFF;
};

export const FIELD_NO_AUTOFILL = {
    autoCorrect: 'off',
    autoCapitalize: 'off',
    spellCheck: 'false',
    'data-lpignore': 'true',
    'data-form-type': 'other',
    'data-1p-ignore': 'true',
};

/*
    🔥 EL TRUCO DEL READONLY

    Devuelve los props que hacen falta. Si el campo ya es de solo
    lectura de verdad, no toca nada.
*/
export const onNoAutofillProps = ({ isReadOnly = false, isDisabled = false } = {}) => {

    if (isReadOnly || isDisabled) return {};

    return {
        readOnly: true,
        onFocus: (event) => event.target.removeAttribute('readonly'),
    };
};

/*
    Placeholder amable por defecto.

    NOTEBOOK tiene muchos formularios y no todos los campos declaran un
    placeholder manualmente. Esta resolución central evita inputs vacíos y
    mantiene ejemplos coherentes sin tener que duplicar textos en cada modal.
    Un placeholder explícito siempre tiene prioridad.
*/
export const onResolveFriendlyPlaceholder = ({ placeholder, label, type = 'text', multiline = false } = {}) => {

    if (placeholder !== undefined && placeholder !== null) return placeholder;

    const NORMALIZED_TYPE = String(type || 'text').toLowerCase();
    if (['hidden', 'checkbox', 'radio', 'range', 'file', 'color'].includes(NORMALIZED_TYPE)) return undefined;

    if (NORMALIZED_TYPE === 'search') return 'Buscar…';
    if (NORMALIZED_TYPE === 'email') return 'Ej.: nombre@dominio.com';
    if (NORMALIZED_TYPE === 'tel') return 'Ej.: +54 9 11 1234 5678';
    if (NORMALIZED_TYPE === 'url') return 'Ej.: https://midominio.com';
    if (NORMALIZED_TYPE === 'number') return 'Ej.: 10';
    if (NORMALIZED_TYPE === 'password') return 'Ingresá la contraseña';
    if (NORMALIZED_TYPE === 'pin') return 'Ej.: 1234';

    const TEXT_LABEL = typeof label === 'string' ? label.trim() : '';
    const KEY = TEXT_LABEL
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    const MATCHES = [
        [/correo|e-?mail/, 'Ej.: nombre@dominio.com'],
        [/telefono|celular|whatsapp/, 'Ej.: +54 9 11 1234 5678'],
        [/sitio|url|enlace|link|repositorio/, 'Ej.: https://midominio.com'],
        [/host|servidor/, 'Ej.: api.midominio.com'],
        [/puerto/, 'Ej.: 5432'],
        [/usuario|user/, 'Ej.: usuario'],
        [/token|api key|clave api/, 'Ej.: token_...'],
        [/stack|tecnolog/, 'Ej.: React, NestJS, PostgreSQL'],
        [/etiquet|tags?/, 'Ej.: frontend, producción'],
        [/nombre del grupo/, 'Ej.: Deploy Frontend'],
        [/compania|empresa/, 'Ej.: Global Bridge Solutions'],
        [/subproyecto/, 'Ej.: Frontend'],
        [/proyecto/, 'Ej.: Sistema nuevo CRM'],
        [/titulo/, 'Ej.: Deploy de producción'],
        [/directorio|ruta/, 'Ej.: /var/www/app'],
        [/comando/, 'Ej.: npm run build'],
        [/descripcion/, 'Ej.: describí brevemente el objetivo…'],
        [/nota|observacion|detalle/, 'Ej.: agregá una aclaración útil…'],
        [/nombre/, 'Ej.: nombre descriptivo'],
    ];

    const MATCH = MATCHES.find(([pattern]) => pattern.test(KEY));
    if (MATCH) return MATCH[1];

    if (multiline) return 'Ej.: escribí acá los detalles necesarios…';
    if (TEXT_LABEL) return `Ej.: ${TEXT_LABEL.toLowerCase()}`;
    return 'Ej.: escribí un valor';
};
